import { createAppRuntime } from "./createAppRuntime";
import { nativePorts } from "./nativePorts";
import { captureException } from "@utils/captureException";

function createDeviceRuntime() {
  const report = (error: unknown) =>
    captureException(error, {
      channel: "error",
      area: "identity",
      operation: "end-data-session",
    });
  const runtime = createAppRuntime(nativePorts(), { report });
  runtime.start().catch(report);
  return runtime;
}

export const deviceRuntime = createDeviceRuntime();
